import { Stack } from '@mui/system'
import React from 'react'
import { categories } from '../../utils/Constants'

const SideBar = ({ SelectedCategory, setSelectedCategory }) => {
    // const SelectedCategory="New"
  return (
    <div>
      <Stack className="overflow-y-auto " direction="row" sx={{overflowY:"auto",height:{sx:"auto",md:"95%"},flexDirection:{sx:"row",md:"column"},}}>
        {
            categories.map((item)=>(
                <button onClick={()=>setSelectedCategory(item.name)} className='flex justify-start gap-5 pb-3   p-2 items-center hover:bg-white   hover:text-black   rounded-r-3xl rounded-l-3xl ' style={{background:item.name===SelectedCategory && "#FC1503"}}>
                    <span>{item.icon}</span>
                    <span>{item.name}</span>
                </button>
            ))
        }
      </Stack>
    </div>
  )
}

export default SideBar
